import { useMemo } from 'react';

import useStores from 'hooks/use-stores';
import { FormattedResponseItem, ResponseItem } from 'pages/Search/components/Database/types';
import isEmpty from 'utils/is-empty';
import { mdToPlain } from 'utils/md-to-plain';
import parseDate from 'utils/parse-data';
import toMeaningfulFixed from 'utils/to-meaningful-fixed';
import Utils from 'utils/Utils';

interface Input {
    items: ResponseItem[];
    exact?: ResponseItem | null;
}

export default function useFormattedData({ items, exact }: Input): FormattedResponseItem[] {
    const { robotTypesStore } = useStores();
    return useMemo(
        () =>
            [exact, ...(items ?? [])]
                .filter((item): item is ResponseItem => !!item)
                .map((item) => {
                    return {
                        image: Utils.getImage(item._source.type),
                        type: robotTypesStore.get(item._source.type),
                        title: item._source.title,
                        description: Utils.trunc(
                            300,
                            mdToPlain(item.flatDescription || '') || mdToPlain(item._source.description || '') || ''
                        ),
                        published: parseDate(item._source.published),
                        views: item._source.viewCount,
                        exact: exact === item,
                        exploits: item._source.exploits_count ?? null,
                        references: item._source.references_count ?? null,
                        affectedSoftware: item._source.affectedSoftware_count ?? null,
                        affectedPackages: item._source.affectedPackages?.length ?? null,
                        affectedConfiguration: item._source.affectedConfiguration?.length ?? null,
                        cvssScore: item._source.cvss?.score ?? null,
                        aiScore:
                            item._source.enchantments?.vulnersScore ?? item._source.enchantments?.score?.value ?? null,
                        epssScore: isEmpty(item._source.epss)
                            ? null
                            : Number(toMeaningfulFixed(Math.max(...item._source.epss.map(({ epss }) => epss)), 3)),
                        isWild:
                            item._source.enchantments?.exploitation?.wildExploited ??
                            item._source.wildExploited ??
                            false,
                        tags: item._source.enchantments?.tags ?? [],
                        href: `/${item._source.type}/${item._source.id}`
                    };
                }),
        [exact, items, robotTypesStore]
    );
}
